import { render, staticRenderFns } from "./ObjectRefsView.vue?vue&type=template&id=6b783cb8&"
import script from "./ObjectRefsView.vue?vue&type=script&lang=js&"
export * from "./ObjectRefsView.vue?vue&type=script&lang=js&"
import style0 from "./ObjectRefsView.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAlert } from 'vuetify/lib/components/VAlert';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VAlert,VIcon})
